export default "__VITE_ASSET__CYwKDCIT__"